function StatusMoreDetailsLink({ text }) {
   return (
      <div className="more-info-link">
         <a 
            href="https://www2.sgc.gov.co/Noticias/tpaginas/Tabla-Esquema-estados-de-alerta-volcanes-SGC.pdf" 
            target="_blank" rel="noopener noreferrer"
         >
            { text ?? "Consultar más detalles sobre estados de alerta" }
         </a>
      </div>
   )
}
export default StatusMoreDetailsLink;